import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedProducts from './components/FeaturedProducts';
import FeatureHighlights from './components/FeatureHighlights';
import ArticlePreview from './components/ArticlePreview';
import NewsletterCTA from './components/NewsletterCTA';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '愽彩糖果',
  url: 'https://bocaicandy.com',
  description: '愽彩糖果网站汇聚海量缤纷糖果，提供多口味、多品类糖果在线选购服务。水果糖果、巧克力、软糖、棒棒糖、糖果礼盒、散装糖果批发一站满足。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://bocaicandy.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <FeatureHighlights />
        <CategoryGrid />
        <FeaturedProducts />
        <ArticlePreview />
        <NewsletterCTA />
      </main>
      <Footer />
    </>
  );
}